export default __webpack_public_path__ + "static/13_34-de860548a1741b5b0ab567c4771cc68a.png";